import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { RealtimeChannelEnum } from '../enums/realtime-channel.enum';

/**
 * Single source of truth for realtime wire event names, e.g. `vehicle/record`.
 * @param subject - App subject the event belongs to.
 * @param channel - Realtime channel being addressed.
 * @returns Wire event name in `{subject}/{channel}` form.
 */
export function buildRealtimeEventName(
  subject: AppSubjectEnum,
  channel: RealtimeChannelEnum,
): string {
  return `${subject}/${channel}`;
}
